import { configureRequestParams, getErrorMessage } from '@/utils/helpers'

import axios from './instance'

/**
 * Gets the list of documents.
 */
export const getDocuments = async ({
  sorting,
  pagination,
  searchTerm,
  filters,
  entity,
  owner,
}) => {
  const combinedFilters = { ...filters }
  if (entity) combinedFilters.entity = entity
  if (owner) combinedFilters.owner = owner
  const params = configureRequestParams(sorting, pagination, searchTerm, combinedFilters)
  try {
    return await axios.get(`/documents/${params}&expand=owner,entity`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Gets a single document by ID.
 */
export const getDocument = async (id) => {
  try {
    return await axios.get(`/documents/${id}/`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Creates a new document.
 */
export const createDocument = async (payload) => {
  try {
    return await axios.post('/documents/', payload)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Deletes a document.
 */
export const deleteDocument = async (id) => {
  try {
    return await axios.delete(`/documents/${id}/`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Updates an existing document.
 */
export const updateDocument = async (id, payload) => {
  const data = { ...payload }
  if (data.entity?.id) {
    data.entity = data.entity.id
  }
  if (data.owner?.id) {
    data.owner = data.owner.id
  }
  try {
    return await axios.patch(`/documents/${id}/`, data)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}
